import React, { FC, useState, useEffect } from 'react';
import JsonData from '../data/releasenote.json';
import { TypeProps } from "./types";
import styled from 'styled-components';

const ReleaseNoteBox = styled.ul`
    list-style-type: none;
`;

const ReleaseNote:FC<TypeProps> = ({content}) => {
    const [notes, setNotes] = useState<{ id: string; text: string; }[]>([]);
    useEffect(() => {
        const data = JsonData;
        if(Object.keys(data).includes(content)) {
            setNotes(data[content as keyof typeof data]);
        }
        else {
            console.error(`'${content}' is not allowed`);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <ReleaseNoteBox>
            {
                notes.map((note, idx) => (
                    <li key={idx}>
                        <h2>{note.id}</h2>
                        <p>{note.text}</p>
                    </li>
                ))
            }
        </ReleaseNoteBox>
    );
};

export default ReleaseNote;